import { getUserData } from "./auth";

export const isAdmin = user => user.roles.includes("System");

export const authenticatedUserHasRole = role => getUserData()?.roles.includes(role) ?? false;
export const authenticatedUserIsAdmin = () => authenticatedUserHasRole("System");
export const authenticatedUserIsRoleManager = () => authenticatedUserHasRole("SystemRoleManagement");
export const authenticatedUserIsManualImport = () => authenticatedUserHasRole("ManualImport");
export const authenticatedUserCanAccessCaoToolStandAlone = () => authenticatedUserHasRole("CaoToolStandAlone");
